import {Component, OnInit} from '@angular/core';
import {ReportService} from '../../../services/report.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';

@Component({
    selector: 'app-announcements-report',
    templateUrl: './announcements-report.component.html',
    styleUrls: ['./announcements-report.component.scss']
})
export class AnnouncementsReportComponent implements OnInit {
    isLoading: boolean;
    announcements: any[] = [];
    originalAnnouncements: any[] = [];

    constructor(private reportService: ReportService,
                public toastMessagesService: ToastMessagesService) {
        this.isLoading = true;
    }

    async ngOnInit() {
        await this.initReports();
    }

    async initReports() {
        try {
            console.log('=== [Αναφορές Ανακοινώσεων] START ===');
            this.isLoading = true;
            this.originalAnnouncements = await this.reportService.getAnnouncementsReport();

            console.log('[Αναφορές] Raw API Response:', this.originalAnnouncements);
            console.log('[Αναφορές] Total records from API:', this.originalAnnouncements?.length || 0);

            // Log unique_ids για να δούμε τι ανακοινώσεις έρχονται
            const uniqueIds = Array.from(new Set(this.originalAnnouncements?.map(a => a.unique_id) || []));
            console.log('[Αναφορές] Unique announcement IDs:', uniqueIds);
            console.log('[Αναφορές] Number of unique announcements:', uniqueIds.length);

            // Log κάθε ανακοίνωση με τα βασικά στοιχεία
            console.log('[Αναφορές] Announcement details:');
            uniqueIds.forEach(uid => {
                const records = this.originalAnnouncements.filter(a => a.unique_id === uid);
                console.log(`  - ID: ${uid}, Title: ${records[0]?.title}, Recipients: ${records.length}`);
            });

            for (const announcement of this.originalAnnouncements) {
                if (this.announcements.findIndex(an => an.unique_id === announcement.unique_id) === -1) {
                    this.announcements.push(announcement);
                }
            }

            console.log('[Αναφορές] Final announcements array (after dedup):', this.announcements);
            console.log('[Αναφορές] Final count:', this.announcements.length);
            console.log('=== [Αναφορές Ανακοινώσεων] END ===');
        } catch (e) {
            console.error('[Αναφορές] ERROR:', e);
            this.toastMessagesService.toastErrorMessage(e.message);
        } finally {
            this.isLoading = false;
        }
    }

    notifyUsers(reportAffirmation: any) {

    }

    navigateToDetails(reportAffirmation: any) {

    }

    calculateOpened(formUniqueId: any) {
        const announcements = this.originalAnnouncements.filter(announcement => announcement.unique_id === formUniqueId);
        const totalSent = announcements.length;
        const completed = announcements.filter(form => form.is_opened === 1).length;
        const result = (completed / totalSent) * 100;
        const percentage = Math.round(result);

        if (percentage === 0) {
            return `(${percentage}%)`;
        } else {
            return `${completed}/${totalSent} (${percentage}%)`;
        }
    }

    calculatePending(formUniqueId: any) {
        const announcements = this.originalAnnouncements.filter(announcement => announcement.unique_id === formUniqueId);
        const totalSent = announcements.length;
        const notOpened = announcements.filter(form => form.is_opened === 0).length;
        const result = (notOpened / totalSent) * 100;
        const percentage = Math.round(result);

        if (percentage === 0) {
            return `(${percentage}%)`;
        } else {
            return `${notOpened}/${totalSent} (${percentage}%)`;
        }
    }
}
